import { URL_API } from 'react-native-dotenv'
import axios from 'axios'
import {
  CustomerPunchCard,
  CustomerPunchCardsResponse,
  PricePreviewRequest,
  PricePreviewResponse,
} from './types'

export async function getCustomerPunchCards(
  establishmentUuid: string,
  token: string,
): Promise<CustomerPunchCard[]> {
  const response = await axios.get<CustomerPunchCardsResponse>(
    `${URL_API}/anonymous/establishments/${establishmentUuid}/customer/punch-cards`,
    { params: { token } },
  )
  return response.data._collection
}

export async function getPricePreview(
  establishmentUuid: string,
  body: PricePreviewRequest,
): Promise<PricePreviewResponse> {
  const response = await axios.post<PricePreviewResponse>(
    `${URL_API}/anonymous/establishments/${establishmentUuid}/appointment/price-preview`,
    body,
  )
  return response.data
}
